<div class="h-screen flex flex-col">

  <app-stepper class='border-t mt-[5%]' [steps]="steps" [currentStep]="currentStep"></app-stepper>

  <form class="flex flex-col flex-1" *ngIf="datosFactura">
    <div class="flex-1 overflow-auto">

      <div [ngSwitch]="currentStep">

        <!-- ==================== STEP 1: DATOS ==================== -->
        <ng-container *ngSwitchCase="1">
          <app-datos-facturas-proveedor [formulario]="datosFactura!.formulario"></app-datos-facturas-proveedor>
        </ng-container>

        <!-- ==================== STEP 2: CONCEPTOS ==================== -->
        <ng-container *ngSwitchCase="2">
          <app-listados-conceptos-proveedor [conceptos]="datosFactura!.conceptos"></app-listados-conceptos-proveedor>
        </ng-container>


        <!-- ==================== STEP 3: TOTALES ==================== -->
        <div *ngSwitchCase="3">
          <app-totales-facturas-proveedor [datosFacturas]="datosFactura"
            (cambioDeStep)="irAlPaso($event)"></app-totales-facturas-proveedor>
        </div>

      </div>
    </div>

    <div class="p-3 border-t mt-auto">

      <div class="flex justify-between">
        <button *ngIf="currentStep > 1" type="button" (click)="prevStep()" [disabled]="this.miniLoader"
          class="flex items-center gap-1 h-9 px-4 py-2 border border-input rounded-md text-sm font-medium hover:bg-accent hover:text-accent-foreground">
          Anterior
        </button>
        <button *ngIf="currentStep === 1" type="button" (click)="confimarCancelar()" [disabled]="this.miniLoader"
          class="h-9 px-4 py-2 border border-input rounded-md text-sm font-medium hover:bg-accent hover:text-accent-foreground">
          Cancelar
        </button>

        <app-mini-loader *ngIf="miniLoader"></app-mini-loader>

        <button *ngIf="currentStep < steps.length" type="button" (click)="nextStep()" [disabled]="this.miniLoader"
          class="flex items-center gap-1 bg-primary text-primary-foreground h-9 px-4 py-2 rounded-md text-sm font-medium">
          Siguiente
        </button>
        <button *ngIf="currentStep === steps.length" type="button" (click)="confirmarGrabarComprobante()"
          [disabled]="this.miniLoader"
          class="bg-primary text-primary-foreground h-9 px-4 py-2 rounded-md text-sm font-medium">
          Guardar y Enviar
        </button>
      </div>
    </div>
  </form>
</div>